const Interno = () => import('@/domains/shared/carteira/shared/layouts/Interno')
const Carteira = () => import('@/domains/shared/carteira/views/Inicio')
const routes = [
    {
        path: '',
        component: Interno,
        children: [
            {
                name: 'carteira',
                path: '/carteira',
                alias: ['/carteira/inicio', '/carteira/sistema/inicio'],
                component: Carteira,
            }
        ]
    },
]
export default routes